import sharedApiRequest from "../services/apiRequest";

export const checkExternalUser = async (email, countryCode) => {
    const res = await sharedApiRequest.get(
      "/users/user",
      {params: {email, country: countryCode}}
    );
    return {
      invite: res === "not_registered",
      internal: res === "is_internal",
      user: !(["not_registered", "is_internal"].includes(res)) ? res : undefined,
    };
  };